<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
    },
    data() {
        return {
            data: {},
            routeName: 'stuff-available',
        }
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            if (vm.$route.query.store_id)
                vm.data.store_id = vm.$route.query.store_id;

            if (vm.$route.query.branch_id)
                vm.data.branch_id = vm.$route.query.branch_id;

            if (vm.$route.query.room_id)
                vm.data.room_id = vm.$route.query.room_id;

            if (vm.$route.query.stuff_id)
                vm.data.stuff_id = vm.$route.query.stuff_id;

            if (vm.$route.query.time_from)
                vm.data.time_from = vm.$route.query.time_from;

            if (vm.$route.query.time_to)
                vm.data.time_to = vm.$route.query.time_to;

            if (vm.$route.query.date)
                vm.data.date = vm.$route.query.date;
        },
        newData() {
            var vm = this;

            var data = {
                keyword: null,
                store_id: null,
                branch_id: null,
                room_id: null,
                stuff_id: null,

                time_from: null,
                time_to: null,

                date: vm.$dateFormat.iso(new Date()),
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;

            vm.success(vm.data);
            vm.$sidebar.hide();
        },
        fetchStore: async function (params) {
            const resp = await this.$api.Store.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchBranch: async function (params) {
            var newParams = {
                ...params,
                store_id: this.data.store_id
            }
            const resp = await this.$api.Branch.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchRoom: async function (params) {
            var newParams = {
                ...params,
                branch_id: this.data.branch_id
            }
            const resp = await this.$api.Room.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchStuff: async function (params) {
            var newParams = {
                ...params,
                room_id: this.data.room_id,
                is_static: 0
            }

            const resp = await this.$api.Stuff.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff_available.label.store')
                            }}</label>
                        <dynamic-select v-model="data.store_id" :placeholder="$t('stuff_available.placeholder.store')"
                            :loadOptions="fetchStore" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff_available.label.branch')
                            }}</label>
                        <dynamic-select v-model="data.branch_id" :placeholder="$t('stuff_available.placeholder.branch')"
                            :loadOptions="fetchBranch" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff_available.label.room')
                            }}</label>
                        <dynamic-select v-model="data.room_id" :placeholder="$t('stuff_available.placeholder.room')"
                            :loadOptions="fetchRoom" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff_available.label.stuff')
                            }}</label>
                        <dynamic-select v-model="data.stuff_id" :loadOptions="fetchStuff"
                            :placeholder="$t('stuff_available.placeholder.stuff')" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff_available.label.date') }}</label>
                        <datepicker v-model="data.date" />
                    </BCol>
                    <BCol lg="6">
                        <label class="form-label" for="product-title-input">{{
                            $t('stuff_available.label.time_from')
                            }}</label>
                        <timepicker v-model="data.time_from" :modeltype="'HH-mm'" :inputtype="'HH:mm'" />
                    </BCol>
                    <BCol lg="6">
                        <label class="form-label" for="product-title-input">{{
                            $t('stuff_available.label.time_to')
                            }}</label>
                        <timepicker v-model="data.time_to" :modeltype="'HH-mm'" :inputtype="'HH:mm'" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="($ac.hasAccess('stuff_available_full_access') || ($ac.hasAccess('stuff_available_list')))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="primary" class="w-100" @click="submit"
                                :disabled="$loading.get([routeName, 'list'].join('_'))">
                                    <loading :loading="$loading.get([routeName, 'list'].join('_'))">
                                        <i class="mdi mdi-magnify me-1"></i>
                                        {{ $t('basic.btn.search') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>